import axios from 'axios'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

const axiosAuthApi = axios.create({
  baseURL: process.env.REACT_APP_APIS_SERVICE_SSO_URL,
  responseType: 'json',
})

axiosAuthApi.defaults.timeout = 60000
axiosAuthApi.defaults.headers.post['Content-Type'] = 'application/json'

axiosAuthApi.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const token = cookies.get('access_kho_token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

axiosAuthApi.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data
  },
  function (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      console.log('401 || 403')
      // alert('saklfmkasdmkasmd')
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error.response.data)
  }
)

export default axiosAuthApi

